import { EntityType, RootState } from "@/shared/types";

export const selectCurrentEntity = (state: RootState): EntityType =>
  state.table.settings.currentEntity;
